import { useEditorConfig } from "../editor-config-context";

import { usePlayground } from "@/components/Playground/playground-store";
import { TemplateFormat } from "@/components/Playground/types";

const useEditorMode = (): TemplateFormat => {
  const config = useEditorConfig();

  try {
    const playground = usePlayground();
    return config.format ?? playground.template_format;
  } catch {
    return config.format ?? "f-string";
  }
};

export default useEditorMode;
